/**
 * Único punto de salida hacia el API. Los componentes no llaman `fetch`:
 * así el manejo de sesión expirada y de errores vive en un solo lugar.
 */

export class ErrorApi extends Error {
  constructor(
    readonly status: number,
    readonly codigo: string,
    mensaje: string,
    readonly detalle?: string,
  ) {
    super(mensaje)
  }
}

async function pedir<T>(ruta: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api${ruta}`, {
    ...init,
    credentials: 'same-origin', // la cookie httpOnly viaja sola
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  })

  if (res.status === 204) return undefined as T

  const cuerpo = await res.json().catch(() => null)

  if (!res.ok) {
    throw new ErrorApi(
      res.status,
      cuerpo?.error ?? 'desconocido',
      cuerpo?.mensaje ?? 'No se pudo completar la operación',
      cuerpo?.detalle,
    )
  }
  return cuerpo as T
}

export const api = {
  get: <T>(ruta: string) => pedir<T>(ruta),
  post: <T>(ruta: string, datos: unknown) =>
    pedir<T>(ruta, { method: 'POST', body: JSON.stringify(datos) }),
  patch: <T>(ruta: string, datos: unknown) =>
    pedir<T>(ruta, { method: 'PATCH', body: JSON.stringify(datos) }),
  delete: <T>(ruta: string) => pedir<T>(ruta, { method: 'DELETE' }),
}

export function queryString(params: Record<string, string | number | undefined>): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ''
}
